export const medicalInfoConstant = {
    GET_BY_PERSON: 'MEDICAL_GET_BY_PERSON',
    GET_BY_ID: 'MEDICAL_GET_BY_ID',
    CHANGE: 'MEDICAL_INFO_CHANGE',
    SAVE: 'MEDICAL_INFO_SAVE'
};
